import { useContext, useEffect, useRef, useState } from 'react'
import { AppContext } from 'contexts/AppContext'
import './Product.css'
import Headline6 from 'components/elements/Headline6'
import ContentSmall from 'components/elements/ContentSmall'
import IconButtonLarge from 'components/elements/IconButtonLarge'
import Heart2 from 'components/icons/Heart2'
import ButtonLarge1 from 'components/elements/ButtonLarge1'
import { createUseStyles } from 'react-jss'
import ContentNormal from 'components/elements/ContentNormal'
import Translate, { translate } from 'utils/Translate'
import Cart1 from 'components/icons/Cart1'
import { useParams } from 'react-router-dom'
import ButtonMedium4 from 'components/elements/ButtonMedium4'
import ButtonInactive from 'components/elements/ButtonInactive'
import _ from 'lodash'
import { callAPI } from "utils/API";
import { parseLinks, priceConvertor } from 'utils/general'
import { Box, Grid2 as Grid, OutlinedInput } from "@mui/material"; 
import CaptionText from 'components/elements/CaptionText'
import { addProductToBasket, addProductQuantityInBasket } from 'utils/basket'
import { callTagManagerEvent, setupBasketData } from 'utils/setup'
import ButtonMedium1 from 'components/elements/ButtonMedium1'
import {Modal} from "react-bootstrap"
import { TaxPercentageForm } from 'components/blocks/taxPercentageForm/TaxPercentageForm'
import { debounce } from 'utils/debouce'
import FreightInfo from 'modules/basket/FreightInfo'
import QuantityInput from 'components/elements/QuantityInput'
import { setupProductImages } from 'utils/productImageHelper'
import ProductContainer from './ProductContainer'

const Product1 = (props) => {
    const {checkBasketForOnePointUser, freightInfo, productInfo} = props
    const defaultCarouselInterval = 1000
    const [productReactionLoading, setProductReactionLoading] = useState(false) 
    const { styleGuide, accessibleShops, basket, userData, setBasket, brandData, langCode, setshowBasketQuickView } = useContext(AppContext)
    const [viewMore, setViewMore] = useState(false);
    const [interval, setinterval] = useState(defaultCarouselInterval);
    const [activeIndex, setactiveIndex] = useState(null);
    const [showProductSize, setShowProductSize] = useState(false);
    const [showVariation, setShowVariations] = useState(false);

    const [productDetails, setproductDetails] = useState({})
    const [ShopID, setShopID] = useState(accessibleShops && accessibleShops.length > 0 ? accessibleShops[0].ShopID : null)
    const [productVariations, setproductVariations] = useState([])
    
    const [variationSizes, setVariationSizes] = useState([])
    const [selectedSize, setselectedSize] = useState(null)

    const [variationColors, setVariationColors] = useState([])
    const [selectedColor, setselectedColor] = useState(null)

    const [variationTitles, setVariationTitles] = useState([])
    const [selectedTitle, setselectedTitle] = useState(null)
    
    const [selectedVariation, setselectedVariation] = useState(null)
    const [selectedVariationInBasket, setselectedVariationInBasket] = useState(null)
    const [selectedVariationStock, setselectedVariationStock] = useState(null)
    const [selectedQuantity, setSelectedQuantity] = useState(1);
    const [basketLoading, setBasketLoading] = useState(false);
    const [userNote, setUserNote] = useState('');

    const { ProductID } = useParams()
    const videoRef = useRef();
    const [isFreightInfoExpanded, setIsFreightInfoExpanded] = useState(false);

    const [errorMessage, seterrorMessage] = useState(null);
    const [showError, setShowError] = useState(false);

    const summaryContentLength = 200
    const sellingPrice = selectedVariation?.sellingPrice || productDetails?.sellingPrice || {type: 'POINTS', amount: 0}
    const pointSuffix = translate("_POINTS_SHORT_", "pt")
    const dkkSuffix = translate("_DKK_", "kr")
    const taxProduct = sellingPrice.type === 'POINTS' && userData.taxPercentage ? Math.ceil(sellingPrice.amount/(brandData.brandPointRatio || 1) * userData.taxPercentage/100) : null
    const headerSpacing = 10

    const handleFreightExpandChange = (expand) => {
        setIsFreightInfoExpanded(expand); // Update parent state with the expand value
    };

    const isOrderLimitExhausted = () => {
        let shop = accessibleShops?.filter(shop => shop?.ShopID === productDetails?.ShopID)
        shop = shop?.length ? shop[0] : null
        if(!shop?.ShopID) return true // Invalid Shop - prevent placing order
        return !shop?.shopSelectionLimit || !shop?.orderCount
            ? false
            : shop?.orderCount >= shop?.shopSelectionLimit
    }

    const shopProductLimit = () => {
        let shop = accessibleShops?.filter(shop => shop?.ShopID === productDetails?.ShopID)
        shop = shop?.length ? shop[0] : null
        return shop?.shopSelectionLimit || 0
    }

    const isUserAdmin = () => {
        if (userData?.userPrivilege == "MANAGE") {
            return true;
        } else {
            return false;
        }
    }

    const basketHasRoomforMoreProducts = (basket, accessibleShops) => {
        let currentShop = accessibleShops.filter(e => e.ShopID === ShopID)
        let productShopSelectionLimit = currentShop && currentShop.length ? currentShop[0].shopSelectionLimit : 0 ;
        if (productShopSelectionLimit === 0) {
            return true
        } 
        if (productShopSelectionLimit > 0 && currentShop.length > 0) {
            const basketShop = basket.filter(basketItem => basketItem.ShopID === currentShop[0].ShopID)
            if (basketShop && basketShop.length >= productShopSelectionLimit) {
                return false
            }
        }
        return true
    }

    const resetVariationDetails = () => {
        setinterval(defaultCarouselInterval)
        setactiveIndex(null)
        setselectedVariation(null)
        setselectedVariationInBasket(null)
        setselectedVariationStock(null)
        setselectedSize(null)
        setselectedColor(null)
        setselectedTitle(null) 
    }

    const assignVariations = async (product) => {
        if(!product || !product.variations || !product.variations.length) {
            setproductVariations([])
            return
        }
        product.variations.forEach(variation => {
            variation.ImageID = variation.images && variation.images.length ? variation.images.map(img => img.ImageID)[0] : null
        });
        setproductVariations(product.variations)
        let sizes = []
        let colors = []
        let titles = []
        product.variations.sort((a,b) => a.poolOrder - b.poolOrder).map(vr => {
            const available = !vr.limitedStock ? true : !vr.variationStock ? false : true
            const colorName = vr.colorName
            if(!sizes.filter(v => v.variant === vr.variationSize).length) !!vr.variationSize && sizes.push({variant: vr.variationSize, available })
            if(!colors.filter(v => v.variant === vr.colorHexcode).length) !!vr.colorHexcode && colors.push({variant: vr.colorHexcode, available, colorName: colorName })
            if(!titles.filter(v => v.variant === vr.variationTitle).length) !!vr.variationTitle && titles.push({variant: vr.variationTitle, available})
        })
        setVariationSizes(sizes)
        setVariationColors(colors)
        setVariationTitles(titles)
        if(product.variations.length === 1 || brandData?.features?.addTobasketWithoutCondition) {
            setselectedVariation(product.variations[0])
            if(brandData?.features?.addTobasketWithoutCondition){
                if(sizes?.length){
                    setselectedSize(sizes[0].variant)
                }
                if(colors?.length){
                    setselectedColor(colors[0].variant)
                }
                if(titles?.length){
                    setselectedTitle(titles[0].variant)
                }
            }
        }
        const productPrice = product.sellingPrice.amount
        // callKlaviyoClientAPI(userData, "Viewed Product", {ProductID: product.ProductID, VariationID: product.variations[0].VariationID, productPrice}, productPrice)
        callTagManagerEvent({
            dataLayer: {
              event: 'view_item',
              ecommerce: {
                currency: 'DKK',
                value: productPrice,
                items: [{
                    item_name: product.elementTitle,
                    item_id: product.ProductID,
                    item_brand: product.manufacturer,
                    item_category: '',
                    item_variant: '',
                    quantity: 1,
                    price: productPrice
                }]
              }
            },
        })
        
        return
    }

    const productReaction = async (product) => {
        setProductReactionLoading(true)
        const ReactionID = product.reaction ? product.reaction.ReactionID : null
        const reactionResponse = await callAPI("/product/reaction", "POST", { body: { ReactionTargetID: product.ProductID, reactionData: JSON.stringify({ ShopID: product.ShopID }), ...(ReactionID && { ReactionID }) } })
        await setupBasketData({userData, setBasket})
        if(reactionResponse !== false) {
            if(reactionResponse?.insertId === 0) {
                product.reaction = null
            } else if (reactionResponse?.insertId) {
                product.reaction = {
                    ReactionID: reactionResponse.insertId
                }
            }
        }
        setProductReactionLoading(false)
    }

    const isDisabled = () => ( variationSizes.length ? selectedSize ? false : true : false ) || (variationColors.length ? selectedColor ? false : true : false) || (variationTitles.length && !variationSizes.length && !variationColors.length ? selectedTitle ? false : true : false )

    const addToCart = debounce(async () => {
        if(isOrderLimitExhausted()) return
        if(!checkBasketForOnePointUser()) return

        if(!selectedVariation) return seterrorMessage(<Translate translationKey='VARIATION_NOT_SELECTED'>Du mangler at vælge variation. </Translate>)
        if(!selectedQuantity) return seterrorMessage(<Translate translationKey='QUANTITY_NOT_SELECTED'>Du mangler at vælge antal. </Translate>)
        if(selectedVariation.limitedStock === 1 && selectedVariation.variationStock < 1) return seterrorMessage(<Translate translationKey='VARIATION_NOT_IN_STOCK'>Produktet er ikke på lager længere.</Translate>)
        if(isDisabled()) {
            ((variationSizes.length && !selectedSize) || (variationColors.length && !selectedColor)) 
                ? setShowProductSize(true)
                : setShowVariations(true)
            return
        }

        setBasketLoading(true)
        // callKlaviyoClientAPI(userData, "Add to cart", {ProductID: productDetails.ProductID, VariationID: selectedVariation.VariationID, productPrice: price}, price)
        callTagManagerEvent({
            dataLayer: {
              event: 'add_to_cart',
              ecommerce: {
                currency: 'DKK',
                value: sellingPrice.amount,
                items: [{
                    item_name: productDetails.elementTitle,
                    item_id: productDetails.ProductID,
                    item_brand: productDetails.manufacturer || '',
                    item_category: productDetails.categories?.length ? productDetails.categories.map(c => c.categoryName).join() : '',
                    item_variant: selectedVariation.variationTitle,
                    quantity: selectedQuantity,
                    price: sellingPrice.amount,
                }]
              }
            },
        });

        setSelectedQuantity(1);
        setUserNote('')

        if(!selectedVariationInBasket || userNote.length) {
            await addProductToBasket(productDetails.ShopID, productDetails.ProductID, selectedVariation.VariationID, selectedQuantity, userNote)
        } else {
            await addProductQuantityInBasket(selectedVariationInBasket.BasketID, selectedVariationInBasket.amount+selectedQuantity)
        }

        await setupBasketData({userData, setBasket})
        setBasketLoading(false)
        setshowBasketQuickView(true)

    }, 500)

    useEffect(() => {
        setShowError(!!errorMessage)
    }, [errorMessage])

    useEffect(() => {
        if(!selectedVariation) {
            setselectedVariationStock(null)
        }else{
            setselectedVariationStock(selectedVariation.limitedStock && selectedVariation.variationStock >= 0 ? selectedVariation.variationStock : null)        
            setselectedVariationInBasket(variationAlreadyInBasket())
        }
    }, [selectedVariation]);

    const variationAlreadyInBasket = () => {
        if(!selectedVariation) return null

        const existing = basket.filter(item => item.ProductID === productDetails.ProductID && item.VariationID === selectedVariation.VariationID)
        return existing.length ? existing[0] : null
    }

    useEffect(() => {
        if(!!productDetails && productDetails.ShopID) setShopID(productDetails.ShopID)
    }, [viewMore, productDetails, variationColors, variationSizes, variationTitles, isFreightInfoExpanded]);

    useEffect(() => {
        resetVariationDetails()
    }, [ProductID, accessibleShops]);

    useEffect(() => {
        if(isDisabled()) {
            setselectedVariation(null)
        }else{

            const variationByTitle = selectedTitle ? productVariations.filter(item => item.variationTitle === selectedTitle) : []
            const variationBySize = selectedSize ? productVariations.filter(item => selectedColor ? item.variationSize === selectedSize && item.colorHexcode === selectedColor : item.variationSize === selectedSize ) : []
            const variationByColor = selectedColor ? productVariations.filter(item => selectedSize ? item.variationSize === selectedSize && item.colorHexcode === selectedColor : item.colorHexcode === selectedColor) : []
            
            if(variationBySize.length === 1) {
                setselectedVariation({...variationBySize[0]})
            }else if(variationByColor.length === 1) {
                setselectedVariation({...variationByColor[0]})
            }else if(variationByTitle.length) {
                setselectedVariation({...variationByTitle[0]})
            }else{
                setselectedVariation(null)
            }
        }

    }, [selectedSize, selectedTitle, selectedColor]);

    useEffect(() => {
        setselectedVariationInBasket(variationAlreadyInBasket())
    }, [selectedVariation]);

    useEffect(() => {
        const exist = variationAlreadyInBasket()
        setselectedVariationInBasket(exist)
    }, [basket]);

    useEffect(() => {
        if (productDetails?.video) {
            setTimeout(() => {
            videoRef.current.play();
            videoRef.current.pause();
        }, 1000);
    }
    }, [productDetails])

    useEffect(() => {
        if(productInfo?.length) {
            setupProductImages(productInfo[0], true)
            setproductDetails(productInfo[0])
            assignVariations(productInfo[0])
        }
    }, [productInfo])
    
    const productDescription = productDetails?.translations?.find((translation) => translation.languageKey === langCode)?.elementContent || productDetails.elementContent

    const ProductSize = () => (
        <Modal show={showProductSize} onHide={() => setShowProductSize(false)} style={{ margin: 'auto' }} centered>
        <Modal.Header className="pb-0 border-0" closeButton style={{ fontSize: 9 }}>
         <Headline6 translationKey="_CHOOSE_SIZE_">Vælg</Headline6>
        </Modal.Header>
       <Modal.Body className="pt-0">
          <ContentSmall translationKey="_CHOOSE_SIZE_TEXT_">Enten “størrelse” eller “farve” eller begge er ikke valgt</ContentSmall>
          <div style={{ 
            display: 'flex',
            float:'right',
           padding: '1rem',
          }}>
           <ButtonMedium1 showIcon={false} translationKey="_OK_" fallbackText="OK" onClick={() => setShowProductSize(false)} />
         </div>
       </Modal.Body>
     </Modal>
      )

      const ProductVariation = () => (
        <Modal show={showVariation} onHide={() => setShowVariations(false)} style={{ margin: 'auto' }} centered>
        <Modal.Header className="pb-0 border-0" closeButton style={{ fontSize: 9 }}>
         <Headline6 translationKey="_CHOOSE_VARIATION_">Vælg</Headline6>
        </Modal.Header>
       <Modal.Body className="pt-0">
          <ContentSmall translationKey="_CHOOSE_VARIATION_TEXT_">Ingen variationer valgt</ContentSmall>
          <div style={{ 
            display: 'flex',
            float:'right',
           padding: '1rem',
          }}>
           <ButtonMedium1 showIcon={false} translationKey="_OK_" fallbackText="OK" onClick={() => setShowVariations(false)} />
         </div>
       </Modal.Body>
     </Modal>
      )
    
    if (isNaN(ProductID) || !productDetails || !productDetails.ProductID) return null
    return <>
        <ProductContainer activeIndex={activeIndex} interval={interval} productDetails={productDetails} ShopID={ShopID} >
            <div className='product-variations' style={{marginTop: 20, marginBottom: 48}}>
                <Grid container rowSpacing={2}>
                    {
                        !!variationSizes.length && <Grid
                            size={{
                                xs: 12,
                                sm: 4
                            }}>
                            <CaptionText style={{color: styleGuide.color6}} translationKey="_PRODUCT_VARIATION_SIZE_LABEL_" fallbackText="Størrelser" /> 
                            <div style={{display: 'flex', flex: 0.5, gap: '0.5rem', marginTop: headerSpacing, flexWrap: 'wrap'}}>
                                {
                                    variationSizes.map((item,idx) => {
                                        const variationIsInStock = selectedSize === item.variant || productVariations.some(v => {
                                            const combinationExists = v.variationSize === item.variant;
                                            const isInStock = !v.limitedStock || (v.variationStock && v.variationStock > 0);
                                            return combinationExists && isInStock;
                                        })

                                        let colorCombinationExists = true
                                        let colorCombinationIsInStock = true
                                        if(variationColors.length) {
                                            colorCombinationExists = selectedSize === item.variant || !selectedColor || productVariations.some(v => v.variationSize === item.variant && v.colorHexcode === selectedColor)
                                            colorCombinationIsInStock = selectedSize === item.variant || !selectedColor || productVariations.some(v => {
                                                const combinationExists = v.variationSize === item.variant && v.colorHexcode === selectedColor;
                                                const isInStock = !v.limitedStock || (v.variationStock && v.variationStock > 0);
                                                return combinationExists && isInStock;
                                            })
                                        } else {
                                        }
                                        
                                        return(
                                            !!item.variant && colorCombinationExists &&
                                            <div key={idx} 
                                                className='size-variation'
                                                onClick={()=> (variationIsInStock && colorCombinationIsInStock) ? setselectedSize(selectedSize === item.variant ? null : item.variant) : null }
                                                style={{border: (selectedSize === item.variant) ? `0.1px solid ${styleGuide.color16}` : `0.1px solid ${styleGuide.color4}`, position: 'relative'}}
                                            >
                                                <CaptionText style={{color: (variationIsInStock && colorCombinationIsInStock) ? styleGuide.color7 : styleGuide.color5, fontWeight: (selectedSize === item.variant) && "600" }} >{item.variant}</CaptionText>
                                                {
                                                    (!variationIsInStock || !colorCombinationIsInStock) && 
                                                        <svg style={{position: 'absolute', width: '73%', height: '73%'}}>
                                                            <line style={{ stroke: styleGuide.color4 }} x1="0" y1="100%" x2="100%" y2="0" />
                                                        </svg>
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </Grid>
                    }
                    {
                        !!variationColors.length && <Grid
                            size={{
                                xs: 12,
                                sm: 6
                            }}>
                            <CaptionText style={{color: styleGuide.color6}} translationKey="_PRODUCT_VARIATION_COLOR_LABEL_" fallbackText="Farver" /> 
                            <div style={{display: 'flex', flex: 0.5, gap: '0.5rem', marginTop: headerSpacing, flexWrap: 'wrap'}}>
                                {
                                    variationColors.map((variationColor, idx) => {
                                        const variationIsInStock = selectedColor === variationColor.variant || productVariations.some(v => {
                                            const combinationExists = v.colorHexcode === variationColor.variant;
                                            const isInStock = !v.limitedStock || (v.variationStock && v.variationStock > 0);
                                            return combinationExists && isInStock;
                                        })
                                        
                                        let sizeCombinationExists = true
                                        let sizeCombinationIsInStock = true
                                        if(variationSizes.length) {
                                            sizeCombinationExists = selectedColor === variationColor.variant || !selectedSize || productVariations.some(v => v.colorHexcode === variationColor.variant && v.variationSize === selectedSize)
                                            sizeCombinationIsInStock = selectedColor === variationColor.variant || !selectedSize || productVariations.some(v => {
                                                const combinationExists = v.colorHexcode === variationColor.variant && v.variationSize === selectedSize;
                                                const isInStock = !v.limitedStock || (v.variationStock && v.variationStock > 0);
                                                return combinationExists && isInStock;
                                            })
                                        }

                                        return(
                                            !!variationColor.variant && sizeCombinationExists &&
                                            <div key={idx} 
                                                data-tooltip={variationColor.colorName}
                                                className='color-variation'
                                                onClick={()=> {
                                                    if(!variationIsInStock || !sizeCombinationIsInStock) return null
                                                    const color = selectedColor === variationColor.variant ? null : variationColor.variant
                                                    setselectedColor(color)

                                                    const variation = color ? productVariations.filter(item => item.colorHexcode === color) : []
                                                    if(variation.length) {
                                                        // setselectedVariation(variation[0])
                                                        const imageIndex = productDetails.images.findIndex( elem => elem.ImageID === variation[0].ImageID)
                                                        setinterval(color && imageIndex > -1 ? null : defaultCarouselInterval)
                                                        setactiveIndex(color && imageIndex > -1 ? imageIndex : null)
                                                    } else {
                                                        setinterval(defaultCarouselInterval)
                                                        setactiveIndex(null)
                                                    }
                                                    
                                                    return
                                                }}
                                                style={{border: (selectedColor === variationColor.variant) ? `0.1px solid ${styleGuide.color16}` : `0.1px solid ${styleGuide.color4}`,}}
                                            >
                                                <div style={{width: 25, height: 25, backgroundColor: `${variationColor.variant}`, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: 'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px'}}>
                                                    {
                                                        (!variationIsInStock || !sizeCombinationIsInStock) && 
                                                            <svg style={{position: 'absolute', width: '73%', height: '73%'}}>
                                                                <line style={{ stroke: styleGuide.color4 }} x1="0" y1="100%" x2="100%" y2="0" />
                                                            </svg>
                                                    }
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </Grid>
                    }
                    {
                        !!variationTitles.length && !variationColors.length && !variationSizes.length && <Grid size={12}>
                            <CaptionText style={{color: styleGuide.color6}} translationKey="_PRODUCT_VARIATION_TITLE_LABEL_" fallbackText="Variationer" /> 
                            <div style={{display: 'flex', flex: 0.5, gap: '0.5rem', marginTop: headerSpacing, flexWrap: 'wrap'}}>
                                {
                                    variationTitles.map((item,idx) => 
                                    !!item.variant &&
                                    <div key={idx} 
                                        className='title-variation'
                                        onClick={()=> {
                                            const title = selectedTitle === item.variant ? null : item.variant
                                            setselectedTitle(title)
                                            // setpauseCarousel(title ? true : false)
                                            const variation = title ? productVariations.filter(item => item.variationTitle === title) : []
                                            if(variation.length) {
                                                // setselectedVariation(variation)
                                                const imageIndex = productDetails.images.findIndex( elem => elem.ImageID === variation[0].ImageID)
                                                setinterval(title && imageIndex > -1 && imageIndex !== activeIndex ? null : defaultCarouselInterval)
                                                setactiveIndex(title && imageIndex > -1 ? imageIndex : null)
                                            } else {
                                                setinterval(defaultCarouselInterval)
                                                setactiveIndex(null)
                                            }
                                            
                                            
                                            return
                                        }}
                                        style={{border: (selectedTitle === item.variant) ? `1px solid ${styleGuide.color4}` : '1px solid transparent',}}
                                    >
                                        <CaptionText style={{color: styleGuide.color7}}>{item.variant}</CaptionText>
                                    </div>)
                                }
                            </div>
                        </Grid>
                    }
                    {
                        <Grid
                            size={{
                                xs: 12,
                                sm: 12
                            }}>
                            <CaptionText
                                style={{ color: styleGuide.color6 }}
                                translationKey="_PRODUCT_QUANTITY_LABEL_"
                                fallbackText="Antal" // Quantity Label
                            />
                            <div style={{ marginTop: headerSpacing }}>
                                <QuantityInput
                                    variantionStock={selectedVariationStock}
                                    quantity={selectedQuantity}
                                    setQuantity={setSelectedQuantity}
                                    shopLimit={shopProductLimit()}
                                />
                            </div>
                        </Grid>
                    }
                    {!!productDetails.enableUserNote &&
                        <Box display={'flex'} flexDirection={'column'} gap={1} sx={{marginTop: 2}}>
                            <CaptionText
                                style={{ color: styleGuide.color6 }}
                                translationKey="_PRODUCT_USER_NOTE_LABEL_"
                                fallbackText="Note"
                            />
                            <OutlinedInput
                                multiline
                                value={userNote}
                                onChange={v => setUserNote(v.target.value)}
                                style={{
                                    borderRadius: 14,
                                    border: `1px solid ${props.error ? styleGuide.color12 : '#777'}`,
                                    fontSize: '14px',
                                    padding: '10px',
                                    width: 250,
                                }}
                            />
                        </Box>
                    }
                </Grid>
            </div>
            <div style={{marginBottom: 10 }}>
                {
                    !!selectedVariationStock 
                    ?   <ContentSmall skipTranslation={true} style={{ color: styleGuide.color6 }}>{selectedVariationStock} stk. på lager</ContentSmall>
                    :   <>&nbsp;</>
                }
            </div>
            {!!productDetails.enableDiscount && !brandData?.features?.disableProductDiscountTag && <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 20, gap: 10 }}>
                <ContentNormal skipTranslation={true} style={{ color: styleGuide.color6, textDecoration: 'line-through'}}>{priceConvertor(brandData, productDetails.sellingPrice.nonDiscountAmount, pointSuffix)}</ContentNormal>
                <ContentNormal skipTranslation={true} style={{ color: styleGuide.color25,}}>{`${translate('_PRODUCT_DISCOUNT_TAG_TEXT_', 'Spar')} ${Math.round((productDetails.sellingPrice.nonDiscountAmount - productDetails.sellingPrice.amount) / productDetails.sellingPrice.nonDiscountAmount * 100)}%`}</ContentNormal>
            </div>}
            {brandData &&
                brandData.features &&
                brandData.features.retailPrice &&
                productDetails &&
                productDetails.retailPrice && (
                    <ContentNormal skipTranslation={true} style={{ color: styleGuide.color7, marginBottom: 20 }}>Vejl. udsalgspris: Kr. {productDetails.retailPrice} inkl. moms</ContentNormal>
                )
            }
            <div style={{marginBottom: headerSpacing, display: 'flex', flexDirection: 'column'}}>
                <div style={{ display: 'flex', flexDirection: 'row',  gap: 20 }}>
                    {!brandData?.features?.disableWishlist && 
                        <IconButtonLarge
                            inverse={productDetails.reaction && productDetails.reaction.ReactionID && productDetails.reaction.ReactionID > 0}
                            icon={<Heart2 fill='white' stroke={styleGuide.color7} strokeWidth="1.5px" />}
                            onClick={() => productReaction(productDetails)}
                            loading={productReactionLoading}
                        />
                    }
                    {basketHasRoomforMoreProducts(basket, accessibleShops) && !isOrderLimitExhausted()
                        ?
                            (((!brandData?.features?.onlyAdminOrderEnabled) || (isUserAdmin())) &&
                                <ButtonLarge1
                                    title={!!brandData?.features?.disablePrice ? null : translate("_ADD_TO_CART_BUTTON_TOOLTIP_", "Læg i kurv")}
                                    onClick={addToCart}
                                    loading={basketLoading}
                                    disabled={brandData?.features?.disableAddtoCartShopIDs?.length && brandData.features.disableAddtoCartShopIDs.includes(ShopID)}
                                    icon={!!brandData?.features?.disablePrice ? null : <Cart1 fill={styleGuide.color1} style={{ marginLeft: '64px' }} />}
                                    fallbackText={!!brandData?.features?.disablePrice ? brandData?.features?.productButtonText[langCode] : !brandData?.features?.disablePoints 
                                        ? priceConvertor(brandData, `${sellingPrice.amount}`, sellingPrice.type === 'POINTS' ? pointSuffix : dkkSuffix)
                                        : translate("_ADD_TO_CART_BUTTON_TOOLTIP_", "Læg i kurv")
                                    }
                                />
                            )
                        :
                            <ButtonInactive
                                buttonText='Du kan ikke vælge flere'
                                style={{ height: '45px', width: '80%' }}
                                disabled={true} />
                    }
                    <ProductSize />
                    <ProductVariation />
                    
                </div>
                {!!taxProduct && <div style={{marginRight: 8, marginLeft: brandData?.features?.disableWishlist ? 0 : 64, marginBottom:16}}>
                    <ContentSmall style={{paddingLeft: 4, paddingRight: 4, fontStyle: 'italic'}} fallbackText={`${translate('_PRODUCT_TAXATION_TEXT_', 'Beskatning kr.')} ${priceConvertor(brandData,taxProduct, '')}`} />
                </div>}
            </div>
            {
                !userData?.taxPercentage && <TaxPercentageForm />
            }
            {!!freightInfo?.enableFreightPriceInterval &&
                <div style={{marginTop: headerSpacing}}>
                    <FreightInfo freightIntervals={freightInfo.freightIntervals} showDeliveryEstimate showAdditionalInfo showLoadFreight onExpandChange={handleFreightExpandChange}/>
                </div>
            }
            <div style={{marginBottom: 40}} />
            <Headline6 style={{ color: styleGuide.color7 }}>
                {translate('_PRODUCT_DESCRIPTION_TAB_CAPTION_', 'Beskrivelse')}
            </Headline6>
            <Box style={{ display: 'flex', flexDirection: 'column', marginTop: headerSpacing }}>
                <ContentSmall 
                    skipTranslation={true}
                >{viewMore ? parseLinks(productDescription) : parseLinks(_.truncate(productDescription, { length: isFreightInfoExpanded ? 50 :summaryContentLength }))}</ContentSmall>
                {
                    !!productDescription && productDescription.length > summaryContentLength &&
                    <div>
                        <ButtonMedium4
                            style={{ marginTop: 20 }}
                            fallbackText={viewMore ? translate('_READ_LESS_BUTTON_TEXT_', 'Læs mindre') : translate('_READ_MORE_BUTTON_TEXT_', 'Læs mere')}
                            showIcon={false}
                            onClick={() => setViewMore(!viewMore)}
                        />
                    </div>
                }
            </Box>
        </ProductContainer>
        <Modal show={showError} onHide={() => setShowError(false)} style={{ margin: 'auto' }} centered>
            <Modal.Header className="pb-0 border-0" closeButton style={{ fontSize: 9 }}>
                <Headline6 style={{ color: styleGuide.color13 }} translationKey="_ERROR_">Fejl</Headline6>
            </Modal.Header>
            <Modal.Body className="pt-4 pb-4">
                <p style={{ textAlign: 'center' }}>{errorMessage}</p>
            </Modal.Body>
        </Modal>
    </>
}

export default Product1